<template>
  <div class="ag-page_policy-block-requiring position-relative">
    <ag-card
      :module="module"
      :key="store.getters.compKey"
      @search="search"
      @main="mainLink"
    ></ag-card>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from "vue";
import AgCard from "@/components/ag-card/index.vue";
import BlockRequiringReview from "@/helpers/pages/BlockRequiringReview";
import router from "./../../router";
import { useStore } from "@/store";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import { Roles } from "@/helpers/enums/Roles";
import { useCommonStore } from "@/stores/common";
import { mapStores } from "pinia";

import moment from "moment";
const store = useStore();
import { onMounted } from "vue";
export default defineComponent({
  name: "BlockRequiringReview",
  components: { AgCard },
  data() {
    return {
      tempData: {
        total: 0,
        rows: [],
      },
    };
  },
  setup() {
    let pStartDate = moment()
      .startOf("day")
      .subtract(7, "days")
      .utc()
      .format("YYYY-MM-DDTHH:mm:ss.SSS");
    //               moment().utc().startOf("day").subtract(7, "days").utc().format("YYYY-MM-DDTHH:mm:ss.SSS")
    let filter = ref({
      page: 1,
      limit: 5,
      policyFileVersion: "",
      type: "",
      startDate: pStartDate,
      endDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"),
      sortColumn: "",
      sortDir: "asc",
      action: "",
      mode: "",
      status: 0,
      decision: "",
    });
    const store = useStore();
    const module = ref(BlockRequiringReview);

    onMounted(() => {
      filter.value.action =
        module.value.filter.filters.filter((x) => x.title == "action")[0]
          .vmodel || "";
      filter.value.mode =
        module.value.filter.filters.filter((x) => x.title == "mode")[0]
          .vmodel || "";
      filter.value.status =
        module.value.filter.filters.filter((x) => x.title == "status")[0]
          .vmodel || "0";
      filter.value.decision =
        module.value.filter.filters.filter((x) => x.title == "decision")[0]
          .vmodel || "";
      const filters = filter.value;
      const options = module.value.component.options;
      module.value.readyToUseFilters = filters;
    });

    const getList = (
      filters = filter.value,
      options = module.value.component.options
    ) => {
      const body = { filters, options };
      store.dispatch(GeneralActionTypes.GET_PROPOSED_UNIQUE_BLOCKS, body);
    };

    const setFilterStatus = () => {
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    };

    const RESETFILTER = filter;

    const searchWithFilters = (param) => {
      filter.value.action =
        module.value.filter.filters.filter((x) => x.title == "action")[0]
          .vmodel || "";
      filter.value.mode =
        module.value.filter.filters.filter((x) => x.title == "mode")[0]
          .vmodel || "";
      filter.value.status =
        module.value.filter.filters.filter((x) => x.title == "status")[0]
          .vmodel || "0";
      filter.value.decision =
        module.value.filter.filters.filter((x) => x.title == "decision")[0]
          .vmodel || "";
      const filters = filter.value;
      const options = module.value.component.options;
      module.value.readyToUseFilters = filters;
      if (options.readyToUseFilters) {
        module.value.readyToUseFilters = options.readyToUseFilters;
        // options.page = 1;
        filters.policyFileVersion = options.readyToUseFilters.policyFileVersion;
        filters.policyFileVersionLimit =
          options.readyToUseFilters.policyFileVersionLimit;
        filters.startDate =
          options.readyToUseFilters && options.readyToUseFilters.startDate
            ? options.readyToUseFilters.startDate
            : moment()
              .utc()
                .startOf("day")
                .subtract(7, "days")
                .utc()
                .format("YYYY-MM-DDTHH:mm:ss.SSS");
        filters.endDate =
          options.readyToUseFilters && options.readyToUseFilters.endDate
            ? options.readyToUseFilters.endDate
            : moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
      }
      getList(filters, options);
      if (!param) {
        router.push({ query: { searchResults: "true" } });
      }
    };

    const resetFilters = () => {
      module.value.filter.filters.forEach((item) => {
        item.vmodel = null;
      });

      searchWithFilters(true);
      let query = Object.assign({}, router.currentRoute.value.query);
      delete query.searchResults;
      router.replace({ query });
    };

    return {
      setFilterStatus,
      searchWithFilters,
      resetFilters,
      filter,
      module,
      getList,
      store,
    };
  },
  computed: {
    group() {
      return store.getters.group;
    },
    ...mapStores(useCommonStore),
  },
  mounted() {
    this.setFilterStatus();
    const filters = this.filter;
    const options = this.module?.component?.options;
    if (this.commonStore.hourDifference) {
      let startDate = new Date();
      let selectedDate = this.commonStore.dateFilter;
      startDate = moment(selectedDate.value)
        .utc()
        .format("YYYY-MM-DDTHH:mm:ss.SSS");
      let endDate = moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS");
      filters.startDate = startDate;
      filters.endDate = endDate;
    }
    this.getList(filters, options);
  },
  methods: {
    mainLink() {
      if (this.tempData.total > 0) {
        this.module.component.options.rows = this.tempData.rows;
        this.module.component.options.total = this.tempData.total;
      } else {
        const filters = this.filter;
        this.module.readyToUseFilters = filters;
        const options = this.module.component.options;
        this.getList(filters, options);
      }
    },
    search() {
      this.tempData.rows = this.module.component.options.rows;
      this.tempData.total = this.module.component.options.total;
      this.module.component.options.rows = [];
      this.module.component.options.total = 0;
    },
  },
  watch: {
    "store.getters.compKey"(newValue, oldValue) {
      const filters = this.filter;
      this.module.readyToUseFilters = filters;
      const options = this.module.component.options;
      options.page = 1;
      filters.page = 1;
      this.getList(filters, options);
    },
  },
});
</script>

<style scoped>
.ag-card_buttons > div:nth-of-type(1) {
  display: none;
}
</style>

<style>
.ag-page_policy-block-requiring .ag-badge {
  line-height: auto;
  margin-left: 8px;
  padding: 0.25em 0.4em !important;
  display: flex;
  align-items: center;
  border-radius: 2px !important;
}

.ag-page_policy-block-requiring
  .ag-card_navigation
  .router-link-exact-active:before {
  bottom: -5px !important;
}

.ag-page_policy-block-requiring .ag-card_navigation a:hover:before {
  bottom: -5px !important;
}

.ag-page_policy-block-requiring .badge-success {
  background: #85933f !important;
}

.ag-page_policy-block-requiring .badge-warning {
  background: #ec9f04 !important;
}

.ag-page_policy-block-requiring .badge-danger {
  background: #bf3000 !important;
}

.ag-page_policy-block-requiring #ag-table .table td {
  padding: 0.75em;
  line-height: 20px;
}

/* .ag-page_policy-block-requiring #ag-table .table tr > td:nth-child(5), */
.ag-page_policy-block-requiring #ag-table .table tr > td:nth-child(6) {
  color: #4c8dbb;
  font-size: 0.9em;
}

.ag-page_policy-block-requiring .ag-card_header {
  box-shadow: none;
  -webkit-box-shadow: none;
}

.ag-page_policy-block-requiring .ag-card_title {
  color: #4c8dbb;
  font-size: 20px;
  font-weight: 600;
  padding: 25px;
  margin: 0 !important;
  position: relative;
}

.ag-page_policy-block-requiring .ag-card_title::after {
  content: "";
  left: 0;
  bottom: -2.5px;
  width: 100%;
  height: 5px;
  background-color: #1878af;
  border-radius: 14px;
  position: absolute;
}

.ag-page_policy-block-requiring #ag-table .table td {
  border-color: #b7c6cd;
  word-break: break-word;
  font-size: 15px;
  line-height: 24px;
  max-width: 330px;
}

.ag-page_policy-block-requiring #ag-table .table td:nth-child(1),
.ag-page_policy-block-requiring #ag-table .table td:nth-child(2) {
  word-break: inherit;
}

.ag-ancestor-list .table td:nth-child(1) {
  word-break: break-word !important;
}

.ag-page_policy-block-requiring #ag-table .table th {
  color: #3a3a3a;
  font-size: 12px;
  padding: 0.75rem;
  word-break: break-all;
}

.ag-page_policy-block-requiring #ag-table .ag-icon_expand {
  position: relative;
  /* display: none; */
}

.ag-page_policy-block-requiring #ag-table a[data-target="#exampleModalCenter"] {
  text-decoration: none;
}

.ag-page_policy-block-requiring
  #ag-table
  a[data-target="#exampleModalCenter"]::before {
  content: "Add Decision";
  display: flex;
  align-items: center;
  justify-content: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  border: 1px solid #d9dfe3;
  border-radius: 4px;
  background: #fff;
  color: #4c8dbb;
  text-decoration: none;
  font-weight: 400 !important;
  font-size: 13px;
}

.ag-page_policy-block-requiring
  #ag-table
  a[data-target="#exampleModalCenter"]
  .ag-icon_expand {
  display: none;
}
</style>
